import { useRouteLoaderData } from "react-router-dom";
import AppErrorPage from "pages/AppErrorPage";
import { LoggedInLayout } from "pages/Layouts/LoggedInLayout";

export function GlobalErrorPage() {
  const globalData = useRouteLoaderData("global");

  return globalData ? <LoggedInLayout /> : <AppErrorPage />;
}
